export default __webpack_public_path__ + "static/media/pic2.a8fd2997.png";